import React from 'react';
import { formatCheckId } from './readinessUtils';
import { ReadinessFixGuide } from './ReadinessFixGuide';
import { getReadinessFixGuide } from './readinessFixRoutes';

function findBlockerCheck(report) {
  const blockerId = report?.primary_blocker?.id;
  if (!blockerId) return null;
  return (report?.checks || []).find((check) => check.id === blockerId) || null;
}

export function PrimaryBlockerPanel({ report }) {
  const primary = report?.primary_blocker;
  if (!primary?.id && !primary?.message) return null;

  const check = findBlockerCheck(report);
  const remediation = check?.remediation;
  const fixSteps = Array.isArray(remediation?.fix_steps) ? remediation.fix_steps : [];
  const likelyCauses = Array.isArray(remediation?.likely_causes) ? remediation.likely_causes : [];
  const guide = check ? getReadinessFixGuide(check) : null;
  const showPlaybookFixSteps = fixSteps.length && !guide?.instructions?.length;

  return (
    <div className="alert alert-danger mb-3">
      <div className="fw-semibold mb-1">Primary blocker</div>
      <div className="mb-1">{primary.message || 'A blocker check failed.'}</div>
      <div className="small text-muted mb-2">{formatCheckId(primary.id)}</div>
      {remediation?.summary ? (
        <div className="small mb-2">
          <span className="fw-semibold">Summary:</span> {remediation.summary}
        </div>
      ) : null}
      {likelyCauses.length ? (
        <div className="small mb-2">
          <div className="fw-semibold">Likely causes</div>
          <ul className="mb-0 ps-3">
            {likelyCauses.map((cause) => (
              <li key={cause}>{cause}</li>
            ))}
          </ul>
        </div>
      ) : null}
      {showPlaybookFixSteps ? (
        <div className="small mb-2">
          <div className="fw-semibold">Fix steps</div>
          <ol className="mb-0 ps-3">
            {fixSteps.map((step) => (
              <li key={step}>{step}</li>
            ))}
          </ol>
        </div>
      ) : null}
      {check ? <ReadinessFixGuide check={check} remediation={remediation} /> : null}
    </div>
  );
}
